import { observer } from 'mobx-react-lite';
import DeleteIcon from '@mui/icons-material/Delete';
import { Avatar, IconButton, Typography } from '@mui/material';

import { useToggle } from '@cutwise/utils';

import {
  RemarkRowDelete,
  RemarkRowIcon,
  RemarkRowRoot,
} from '@/dmdrive/topic/components/Topic/RightSidebar/Remarks/RemarkRow/RemarkRow.styles';
import { useTopicStore } from '@/dmdrive/topic/components/Topic/TopicStore';
import { MARK_ICON_MAP } from '@/dmdrive/topic/constants/topic';
import { TopicMark } from '@/dmdrive/topic/entities/TopicMark';

interface AnnotationRowProps {
  mark: TopicMark;
}

function RemarkRow(props: AnnotationRowProps) {
  const { mark } = props;
  const { topic, deleteMark } = useTopicStore();

  const [isDeleting, startDeleting, finishDeleting] = useToggle();

  if (!topic) {
    return null;
  }

  async function onDelete() {
    startDeleting();

    await deleteMark(mark.id);

    finishDeleting();
  }

  return (
    <RemarkRowRoot>
      <RemarkRowIcon>
        <Avatar sx={{ width: '2rem', height: '2rem' }}>{MARK_ICON_MAP[mark.meta.type]}</Avatar>
      </RemarkRowIcon>

      <div>
        <Typography variant="body2">{mark.meta.text}</Typography>

        <Typography variant="caption">{`by ${mark.user.username}`}</Typography>
      </div>

      <RemarkRowDelete>
        <IconButton size="small" color="error" onClick={onDelete} disabled={isDeleting}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      </RemarkRowDelete>
    </RemarkRowRoot>
  );
}

export default observer(RemarkRow);
